import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";

function MiniStat({ icon, label, value }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, p: 1, borderRadius: 1.5, bgcolor: "rgba(7,94,84,0.06)" }}>
      {icon}
      <Box>
        <Typography variant="caption" color="#64748b" fontWeight={600} display="block">{label}</Typography>
        <Typography fontWeight={700} fontSize={14} color="#1e293b">{value}</Typography>
      </Box>
    </Box>
  );
}

export default function ContactHealthWidget({ data }) {
  if (!data) return null;
  const {
    totalContacts, activeContacts, newContactsToday, blockedContacts,
    staleContacts, optedIn, optedOut, optInRate, qualityScore,
  } = data;

  return (
    <Paper className="glass-card" sx={{ p: 3 }}>
      <Typography fontWeight={700} fontSize={15} color="#1e293b" mb={2}>Contact Health</Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
        <PeopleIcon sx={{ fontSize: 32, color: "#075e54" }} />
        <Box>
          <Typography fontWeight={800} fontSize={24} color="#1e293b">{totalContacts}</Typography>
          <Typography variant="caption" color="#64748b">total contacts</Typography>
        </Box>
      </Box>
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5, mb: 2 }}>
        <MiniStat icon={<PersonAddIcon sx={{ fontSize: 16, color: "#3b82f6" }} />}
          label="Active" value={activeContacts} />
        <MiniStat icon={<PersonAddIcon sx={{ fontSize: 16, color: "#22c55e" }} />}
          label="New Today" value={newContactsToday} />
        <MiniStat icon={<DoNotDisturbIcon sx={{ fontSize: 16, color: "#ef4444" }} />}
          label="Blocked" value={blockedContacts} />
        <MiniStat icon={<HourglassBottomIcon sx={{ fontSize: 16, color: "#f59e0b" }} />}
          label="Stale" value={staleContacts} />
      </Box>
      <Box sx={{
        display: "flex", justifyContent: "space-between",
        p: 1.5, borderRadius: 2, bgcolor: "rgba(7,94,84,0.06)", mb: 1,
      }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <ThumbUpIcon sx={{ fontSize: 16, color: "#22c55e" }} />
          <Typography variant="body2" color="#475569" fontWeight={600}>
            Opted In: {optedIn}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <ThumbDownIcon sx={{ fontSize: 16, color: "#ef4444" }} />
          <Typography variant="body2" color="#475569" fontWeight={600}>
            Opted Out: {optedOut}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="caption" color="#64748b">Opt-in Rate</Typography>
        <Typography variant="caption"
          color={optInRate >= 80 ? "#22c55e" : "#ef4444"} fontWeight={700}>
          {optInRate}%
        </Typography>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 0.5 }}>
        <Typography variant="caption" color="#64748b">Quality Score</Typography>
        <Typography variant="caption"
          color={qualityScore >= 80 ? "#22c55e" : qualityScore >= 50 ? "#f59e0b" : "#ef4444"}
          fontWeight={700}>
          {qualityScore}/100
        </Typography>
      </Box>
    </Paper>
  );
}
